import { PortfolioMenu } from '@unistocks/features/portfolios/components/portfolio-settings/portfolio-menu';
import { usePortfoliosGetQuery } from '@unistocks/proxy/axios-client/PortfoliosQuery';
import { HasId } from '@unistocks/types/has-id';
import { memo } from 'react';

export const PortfolioHeaderRight = memo<HasId>(({ id }) => {
  const { data: portfolio, isSuccess } = usePortfoliosGetQuery({ id });

  return isSuccess ? <PortfolioMenu portfolio={portfolio} /> : null;
});

PortfolioHeaderRight.displayName = 'PortfolioHeaderRight';
